module.exports = __webpack_public_path__ + "static/img/cloud-platform1.27fdae2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cloud-platform1.jpg
// module id = HpQk
// module chunks = 0